import React, { useState } from 'react';
import toast from 'react-hot-toast';
import { SIGNAL_ASSET_TYPES, SIGNAL_SYNC_KEYS, clearSignalSyncs, getSignalSyncs } from '../utils/signalSync';

const ResetLastSignalSyncPage = () => {
  // หุ้น / คริปโต เก็บ syncKey แยกกัน → แสดงและล้างทั้งสองค่า
  const [currentValues, setCurrentValues] = useState(getSignalSyncs);

  const handleReset = () => {
    const confirmed = window.confirm(
      'ยืนยันการล้างค่า last_signal_sync_time ?\n\nกล่องอัพเดตแนวรับ-แนวต้านของแอดมินจะถูกรีเซ็ต (แต่เส้นที่เคย Import ไปแล้วจะไม่หาย)'
    );
    if (!confirmed) return;

    clearSignalSyncs();
    setCurrentValues(getSignalSyncs());
    toast.success('ล้างค่า last_signal_sync_time เรียบร้อยแล้ว');
  };

  return (
    <div
      style={{
        background: '#18181b',
        color: '#eee',
        maxWidth: 700,
        margin: '40px auto',
        padding: 24,
        borderRadius: 12,
      }}
    >
      <h1 style={{ color: '#ffd600' }}>รีเซ็ต last_signal_sync_time</h1>

      <p style={{ marginTop: 16, lineHeight: 1.7 }}>
        ปุ่มนี้จะลบค่า <code style={{ color: '#ffd600' }}>last_signal_sync_time</code> ออกจาก
        localStorage ของเบราว์เซอร์นี้
      </p>

      <p style={{ marginTop: 8, lineHeight: 1.7 }}>
        <strong>ผลที่จะเกิดขึ้นหากกดปุ่มนี้:</strong><br />
        กล่องแจ้งเตือนการอัพเดตแนวรับ-แนวต้านของแอดมิน (Signal Update) จะถูกรีเซ็ต
        ระบบจะดึงสัญญาณย้อนหลังทั้งหมดมาแสดงใหม่อีกครั้ง เสมือนยังไม่เคย Sync มาก่อน
      </p>

      <p style={{ marginTop: 8, lineHeight: 1.7, color: '#9ae6b4' }}>
        เส้นแนวรับ-แนวต้านที่เคย Import เข้าไปในกราฟแต่ละหุ้นแล้ว (chartLines) จะ
        <strong> ไม่หาย</strong> เพราะข้อมูลนั้นถูกเก็บแยกไว้คนละส่วนกัน
      </p>

      <div
        style={{
          marginTop: 16,
          padding: 12,
          borderRadius: 8,
          background: '#27272a',
          fontSize: 14,
          wordBreak: 'break-all',
        }}
      >
        {SIGNAL_ASSET_TYPES.map((type) => (
          <div key={type}>
            {SIGNAL_SYNC_KEYS[type]} ({type}): {currentValues[type] || <em style={{ color: '#888' }}>(ไม่มีค่า)</em>}
          </div>
        ))}
      </div>

      <button
        onClick={handleReset}
        style={{
          marginTop: 24,
          background: '#dc2626',
          color: '#fff',
          fontWeight: 700,
          padding: '10px 20px',
          borderRadius: 8,
          border: 'none',
          cursor: 'pointer',
        }}
      >
        ล้างค่า last_signal_sync_time
      </button>
    </div>
  );
};

export default ResetLastSignalSyncPage;
